var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c("CabeceraModalEditar", {
        attrs: {
          titulo: "Editar Descarga de Información",
          form: Object.values(_vm.pasos).find(function(x) {
            return x.step === _vm.pasoActivoIndex
          }).formState,
          pasos: _vm.pasos,
          entidad: "Descarga de Información",
          "paso-activo-index": _vm.pasoActivoIndex,
          inactivable: _vm.modificable,
          estadoEntidad: _vm.estadoEntidad,
          mensajeInactivo: _vm.mensajeInactivo
        },
        on: {
          cerrar: _vm.handleCerrar,
          guardar: _vm.handleGuardar,
          inactivo: _vm.handleInactivo
        }
      }),
      _c("CrudStepsNavBar", {
        attrs: { pasos: _vm.pasos },
        model: {
          value: _vm.pasoActivoIndex,
          callback: function($$v) {
            _vm.pasoActivoIndex = $$v
          },
          expression: "pasoActivoIndex"
        }
      }),
      _vm.descargaActividadDetalle
        ? _c(
            "ContenidoModal",
            [
              _c("DescargaActividadForm", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.pasoActivoIndex === _vm.pasos.informacionGeneral.step,
                    expression:
                      "pasoActivoIndex === pasos.informacionGeneral.step"
                  }
                ],
                attrs: {
                  "descarga-actividad": _vm.descargaActividadDetalle,
                  edicion: true,
                  idServicio: _vm.descargaActividad.id,
                  "test-id": "EditarDescargaActividadModal"
                },
                on: { change: _vm.handleInformacionGeneralChange }
              }),
              _c("AsociarFlotaEtiquetaVehiculoIndividual", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.pasoActivoIndex === _vm.pasos.asociarVehiculos.step,
                    expression:
                      "pasoActivoIndex === pasos.asociarVehiculos.step"
                  }
                ],
                attrs: {
                  "flotas-id-seleccionar":
                    _vm.descargaActividadDetalle &&
                    _vm.descargaActividadDetalle.flotasId,
                  "etiquetas-id-seleccionar":
                    _vm.descargaActividadDetalle &&
                    _vm.descargaActividadDetalle.etiquetasId,
                  "vehiculos-id-seleccionar":
                    _vm.descargaActividadDetalle &&
                    _vm.descargaActividadDetalle.vehiculosId,
                  "col-def-vehiculo": _vm.vehiculoColDefs,
                  esEditar: true
                },
                on: { change: _vm.handleAsociacionesChange }
              }),
              _c(
                "PasoAsociacion",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.pasoActivoIndex ===
                        _vm.pasos.asociarActividades.step,
                      expression:
                        "pasoActivoIndex === pasos.asociarActividades.step"
                    }
                  ]
                },
                [
                  _c("AsociarTiposActividad", {
                    attrs: { esEditar: true },
                    model: {
                      value: _vm.descargaActividadDetalle.tiposActividadId,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.descargaActividadDetalle,
                          "tiposActividadId",
                          $$v
                        )
                      },
                      expression: "descargaActividadDetalle.tiposActividadId"
                    }
                  })
                ],
                1
              ),
              _c(
                "PasoAsociacion",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.pasoActivoIndex ===
                        _vm.pasos.asociarDispositivos.step,
                      expression:
                        "pasoActivoIndex === pasos.asociarDispositivos.step"
                    }
                  ],
                  attrs: { esEditar: true }
                },
                [
                  _c("AsociarDispositivos", {
                    attrs: { esEditar: true },
                    model: {
                      value: _vm.descargaActividadDetalle.dispositivosId,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.descargaActividadDetalle,
                          "dispositivosId",
                          $$v
                        )
                      },
                      expression: "descargaActividadDetalle.dispositivosId"
                    }
                  })
                ],
                1
              ),
              _c("AsociarCampos", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.pasoActivoIndex === _vm.pasos.seleccionarCampos.step,
                    expression:
                      "pasoActivoIndex === pasos.seleccionarCampos.step"
                  }
                ],
                attrs: { esEditar: true },
                model: {
                  value: _vm.descargaActividadDetalle.camposId,
                  callback: function($$v) {
                    _vm.$set(_vm.descargaActividadDetalle, "camposId", $$v)
                  },
                  expression: "descargaActividadDetalle.camposId"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c("Confirmation", {
        attrs: {
          show: _vm.permiteContinuarConfirm,
          titulo: _vm.tituloPermiteContinuar,
          mensaje: _vm.mensajePermiteContinuar,
          items: _vm.itemsNoValidos,
          mostrarBoton: false
        },
        on: {
          modalConfirmationEmit: function($event) {
            _vm.permiteContinuarConfirm = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }